export const categoryTeams = {
  'Mens Singles Open': [],
  'Womens Doubles Open': [],
  'Mix Doubles Open': [],
  'Split Age 35+': [],
  'Mens Doubles Open': [],
  '30+ Doubles': [],
};

// Helper function to get teams for a specific category
export const getTeamsByCategory = (category) => {
  return categoryTeams[category] || [];
};

// Helper function to get all available categories
export const getAllCategories = () => {
  return Object.keys(categoryTeams);
};

// Helper function to check if a category exists
export const categoryExists = (category) => {
  return categoryTeams.hasOwnProperty(category);
};
